import WaveSurfer from 'wavesurfer.js';
import RecordPlugin from 'wavesurfer.js/dist/plugins/record';
import React, { useEffect, useRef } from 'react';

const WaveForm = ({ progressValue }) => {
  const waveformRef = useRef(null);
  const wavesurferRef = useRef(null);
  const cursorRef = useRef(null);
  const isStopped = useRef(false); // track if mic is already stopped

  useEffect(() => {
    if (!waveformRef.current) return;

    wavesurferRef.current = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: '#B2EA47',
      interact: false,
      cursorWidth: 0,
      height: 100,
      plugins: [
        RecordPlugin.create({
          scrollingWaveform: true,
          renderRecordedAudio: false,
        }),
      ],
    });

    const recordPlugin = wavesurferRef.current.plugins?.[0];
    recordPlugin?.startRecording();

    return () => {
      recordPlugin?.stopRecording();
      wavesurferRef.current.destroy();
    };
  }, []);

  useEffect(() => {
    const cursor = cursorRef.current;
    if (cursor && waveformRef.current) {
      const totalWidth = waveformRef.current.clientWidth;
      const progress = Math.min(progressValue / 100, 1);
      // cursor.style.left = `${progress * totalWidth}px`;
      cursor.style.width = "0px";

      if (progress >= 1 && wavesurferRef.current && !isStopped.current) {
        const recordPlugin = wavesurferRef.current.plugins?.[0];
        recordPlugin?.stopRecording();
        isStopped.current = true; 
      }
    }
  }, [progressValue]);

  return (
    <div className="mic-waveform-container">
      <div ref={waveformRef} id="waveform" className="mic-waveform-wave" />
      <div ref={cursorRef} className="mic-waveform-cursor" />
    </div>
  );
};

export default WaveForm;
